const whatsapp = "https://wa.me/971501511295";
const telegram = "https://t.me/devspila";
const linkedin = "https://www.linkedin.com/company/spiladev/";
const github = "https://github.com/spila-dev";
const gmail = "mailto:dev.spila@gmail.com";
const instagram = "";

export const contactLink = {whatsapp,telegram,linkedin,github,gmail,instagram};
